/**
 * Member-facing copy for social-link error keys the app API can return.
 *
 * The website keeps a parallel map in
 * PlaygroundZend public/website/assets/js/pages/social-sign-in.js
 * (mapErrorToMessage). These website keys are intentionally absent here:
 * - linking_handle_send_limit: the app API reports that limit as rate_limited.
 * - invalid_provider, invalid_token, session_required: accept-token failures,
 *   not email or code rejects. invalid_token is mapped in socialSignInSdk.
 * - The website CSRF key: website session only.
 * Add a key here only when the app API can return it.
 *
 * Terminal errors clear the stored handoff — the caller checks isTerminalError().
 */
const errorMessages: Record<string, string> = {
  invalid_email: "Please enter a valid email address.",
  private_relay_not_allowed: "Apple Hide My Email addresses cannot receive receipts and instructional videos. Enter an email address you can open.",
  rate_limited: "Too many attempts. Please wait a moment and try again.",
  invalid_code: "Invalid verification code. Please check and try again.",
  expired_code: "Verification code has expired. Please request a new one.",
  wrong_code: "Incorrect verification code. Please try again.",
  recaptcha_required: "Security check failed. Please try again.",
  recaptcha_failed: "Security check failed. Please try again.",
  delivery_failed: "We could not send the verification email. Please try again.",
  linking_token_invalid: "Your sign-in session has expired. Please start over.",
  identity_already_linked: "This social account is already linked to a different Playground account.",
  provider_already_linked: "This Playground account is already linked to a different social login.",
};

const terminalErrors = new Set([
  "linking_token_invalid",
  "identity_already_linked",
  "provider_already_linked",
]);

export const socialLinkErrors = {
  mapErrorToMessage(error: string): string {
    return errorMessages[error] ?? "An error occurred. Please try again.";
  },

  isTerminalError(error: string): boolean {
    return terminalErrors.has(error);
  },
};
